import * as Clipboard from 'expo-clipboard';
import { useState } from 'react';
import Text from '@/components/UI/Text';
import useHaptics from '@/hooks/useHaptics';
import useTimer from '@/hooks/useTimer';
import useUserId from '@/hooks/useUserId';
import ActionButton from '../../UI/ActionButton';
import Box from '../../UI/Box';
import Card from '../../UI/Card';
import CheckboxItem from '../../UI/CheckboxRow';
import Icon from '../../Unistyles/Icon';
import Tag from '../../Unistyles/Tag';

export default function EventShareCalendarSync() {
  const [directCalendar, setDirectCalendar] = useState(false);
  const userId = useUserId();

  const [copyButton, setCopyButton] = useTimer(
    {
      label: 'Copy',
      disabled: false,
    },
    2000,
  );

  const calendarSubscriptionUrl = `${process.env.EXPO_PUBLIC_SERVICES_URL}/calendarFeed/person/${userId}`;
  const calendarSubscriptionDirectUrl = `${process.env.EXPO_PUBLIC_SERVICES_URL}/calendarFeed/person/${userId}?direct=1`;

  const onCopy = useHaptics(async (url: string) => {
    await Clipboard.setStringAsync(url);

    setCopyButton({
      label: 'Copied',
      disabled: true,
    });
  });

  return (
    <Card space="lg" p="lg" w="full">
      <Box
        space="md"
        direction="horizontal"
        justifyContent="space-between"
        flexWrap="wrap"
        alignItems="center"
      >
        <Box
          direction="horizontal"
          alignItems="center"
          justifyContent="flex-start"
          space="md"
          flexWrap="wrap"
        >
          <Box alignItems="center" direction="horizontal" space="md" flex>
            <Icon name="sync-outline" variant="info" size="3xl" />
            <Box space="sm" alignItems="flex-start">
              <Text size="3xl" variant="info" flexShrink={1}>
                Calendar Sync
              </Text>
              <Tag variant="info" label="Recommended" />
            </Box>
          </Box>
        </Box>
      </Box>
      <Text>Sync to your calendar app of choice!</Text>
      <Text>
        Import this link in your calendar app, and it will live update when
        there are changes in 1Time.
      </Text>
      <Card alignItems="center" direction="vertical" w="full">
        <CheckboxItem
          variant="primary"
          value={!!directCalendar}
          onValueChange={() => setDirectCalendar(!directCalendar)}
        >
          <Text>Sync only events you're directly participating in?</Text>
        </CheckboxItem>
        <Box
          w="full"
          p="lg"
          flex
          alignItems="center"
          justifyContent="flex-start"
          direction="horizontal"
          space="md"
        >
          <Box flex>
            <Text variant="typographySecondary" numberOfLines={1}>
              {directCalendar
                ? calendarSubscriptionDirectUrl
                : calendarSubscriptionUrl}
            </Text>
          </Box>
          <ActionButton
            forceLabel
            icon="copy-outline"
            variant="secondary"
            label={copyButton.label}
            onPress={() =>
              onCopy(
                directCalendar
                  ? calendarSubscriptionDirectUrl
                  : calendarSubscriptionUrl,
              )
            }
            disabled={copyButton.disabled}
          />
        </Box>
      </Card>
    </Card>
  );
}
